import react from 'react';

('use strict');
Object.defineProperty(exports, '__esModule', {
  value: true,
});
var _react = _interopRequireDefault(react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function handleClick(e) {
  window.open(e.currentTarget.href, '_blank');
}
var Link = function Link(props) {
  var contentState = props.contentState,
    children = props.children,
    entityKey = props.entityKey;
  var _contentState$getEnti = contentState.getEntity(entityKey).getData(),
    href = _contentState$getEnti.href,
    title = _contentState$getEnti.title;
  if (!/\:/.test(href)) {
    href = `http://${href}`;
  }
  return /*#__PURE__*/ _react.default.createElement(
    'a',
    {
      href: href,
      title: title,
      onClick: handleClick,
    },
    children,
  );
};
var _default = Link;
export default _default;
